export const DASHBOARD_GET_PROFILE_START = "DASHBOARD_GET_PROFILE_START";
export const DASHBOARD_GET_PROFILE_SUCCESS = "DASHBOARD_GET_PROFILE_SUCCESS";
export const DASHBOARD_GET_PROFILE_ERROR = "DASHBOARD_GET_PROFILE_ERROR";

export const DASHBOARD_SAVE_SIGNATURE_START = "DASHBOARD_SAVE_SIGNATURE_START";
export const DASHBOARD_SAVE_SIGNATURE_SUCCESS = "DASHBOARD_SAVE_SIGNATURE_SUCCESS";
export const DASHBOARD_SAVE_SIGNATURE_ERROR = "DASHBOARD_SAVE_SIGNATURE_ERROR";

export const DASHBOARD_INIT_PROFILE_EDIT = "DASHBOARD_INIT_PROFILE_EDIT";
